import React, { Component } from 'react';
import styles from './Parking.css';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';

class Parking extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Hayward Place - Football Parking</title>
          <meta
            name="description"
            content="Husker football parking at Hayward Place in Lincoln, Nebraska's North Bottoms neighborhood. Walking distance from downtown Lincoln, the Haymarket, and Memorial Stadium."
          />
        </Helmet>
        <div className={styles['hero-image']}>
          <img
            src="images/compressed/hayward-go-big-red-cropped.png"
            alt="Historic Hayward Place condominiums and apartments in Lincoln, Nebraska."
          />
        </div>
        <div className={styles.divider}>
          <hr />
          <div className={styles.heading}>Football Parking</div>
          <hr />
        </div>
        <div className={styles.section}>
          <p>
            Hayward Place offers safe and convenient football parking, minutes
            away from Memorial Stadium and downtown Lincoln. Our paved, private
            lot is stress free: no double parking and no long lines.
          </p>
        </div>
        <hr />
        <div className={classNames(styles.section, styles['pass-types'])}>
          <div className={classNames(styles.pass, styles['season-pass'])}>
            <div>
              <div className={styles.title}>Season Pass</div>
              <div className={styles.description}>
                Enjoy peace of mind knowing that we have a space reserved just
                for you all season. Our season pass also includes the following
                year's Spring Game.
              </div>
            </div>
            <div className={styles.price}>
              <span>$175</span>
              <a href="mailto:parking@hayward.place?subject=Football%20Parking%20Season%20Pass&body=I'm interested in a season pass for football season. Can you send me more information?">
                Reserve Today
              </a>
            </div>
          </div>
          <div className={classNames(styles.pass, styles['day-of'])}>
            <div>
              <div className={styles.title}>Game Day</div>
              <div className={styles.description}>
                If you can't commit to a whole season, unreserved spaces are
                first-come-first-serve on game day. Sales start 3 hours prior to
                kickoff.
              </div>
            </div>
            <div className={styles.price}>
              <span>$25</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Parking;



// WEBPACK FOOTER //
// ./src/Parking.js